import { render, staticRenderFns } from "./popup-gift-card.vue?vue&type=template&id=0902e2cd&scoped=true&"
import script from "./popup-gift-card.vue?vue&type=script&lang=js&"
export * from "./popup-gift-card.vue?vue&type=script&lang=js&"
import style0 from "./popup-gift-card.vue?vue&type=style&index=0&id=0902e2cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0902e2cd",
  null
  
)

export default component.exports